import React from 'react';
import { Link } from 'react-router-dom';
import { TfiPackage, TfiSettings } from 'react-icons/tfi';
import { TbMenuOrder, TbHotelService } from 'react-icons/tb';
import { BsInfoLg } from 'react-icons/bs';
import { CgNotes } from 'react-icons/cg';
import { RiProductHuntLine, RiDeleteBin3Line } from 'react-icons/ri';
import { MdAddLocationAlt } from 'react-icons/md';
import {
  MdDashboard,
  MdMiscellaneousServices,
  MdOutlineCategory,
  MdPeopleAlt,
  MdOutlineCall,
  MdOutlineSettingsInputComposite,
  MdNotificationsActive,
} from 'react-icons/md';

class SideNavBar extends React.Component {
  render() {
    return (
      <nav className="pcoded-navbar noprint" id="admin_menu">
        <div className="pcoded-inner-navbar main-menu">
          <ul className="pcoded-item pcoded-left-item">
            <li className="">
              <Link to="/">
                <span className="pcoded-micon">
                  <MdDashboard />
                </span>
                <span className="pcoded-mtext">Dashboard</span>
              </Link>
            </li>
            <li className="">
              <Link to="/Packages">
                <span className="pcoded-micon">
                  <TfiPackage />
                </span>
                <span className="pcoded-mtext">Packages</span>
              </Link>
            </li>
            <li className="pcoded-hasmenu">
              <a href="javascript:void(0)">
                <span className="pcoded-micon">
                  <MdPeopleAlt />
                </span>
                <span className="pcoded-mtext">Customers</span>
              </a>
              <ul className="pcoded-submenu">
                <li className="">
                  <Link to="/user">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-users-alt-3"></i>
                    </span>
                    <span className="pcoded-mtext">User</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/service-provider">
                    <span className="pcoded-micon">
                      <i className="icofont icofont-users-alt-3"></i>
                    </span>
                    <span className="pcoded-mtext">Service Provider</span>
                  </Link>
                </li>
              </ul>
            </li>
            <li className=" pcoded-hasmenu">
              <a href="javascript:void(0)">
                <span className="pcoded-micon">
                  <MdMiscellaneousServices />
                </span>
                <span className="pcoded-mtext">Service Providers</span>
              </a>
              <ul className="pcoded-submenu">
                <li className=" ">
                  <Link to="/ServiceProviders/Garage">
                    <span className="pcoded-mtext">Garage</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/ServiceProviders/SpareParts">
                    <span className="pcoded-mtext">Spare Parts</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/ServiceProviders/CarDealers">
                    <span className="pcoded-mtext">Car Dealers</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/ServiceProviders/CarForSale">
                    <span className="pcoded-mtext">Cars For Sale</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/ServiceProviders/RentCar">
                    <span className="pcoded-mtext">Rent a Car</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/ServiceProviders/Taxi">
                    <span className="pcoded-mtext">Taxi</span>
                  </Link>
                </li>

                <li>
                  <Link to="/ServiceProviders/CarWash">
                    <span className="pcoded-mtext ">Car Wash</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/ServiceProviders/CarTowing">
                    <span className="pcoded-mtext">Car Towing</span>
                  </Link>
                </li>
                <li>
                  <Link to="/ServiceProviders/CarInsurance">
                    <span className="pcoded-mtext">Car Insurance</span>
                  </Link>
                </li>
                <li>
                  <Link to="/ServiceProviders/DrivingSchool">
                    <span className="pcoded-mtext">DrivingSchool</span>
                  </Link>
                </li>
                <li>
                  <Link to="/ServiceProviders/CarProtection">
                    <span className="pcoded-mtext">Car Protection</span>
                  </Link>
                </li>
                <li>
                  <Link to="/ServiceProviders/CarConditioning">
                    <span className="pcoded-mtext">Car Conditioning</span>
                  </Link>
                </li>
                <li>
                  <Link to="/ServiceProviders/QuickService">
                    <span className="pcoded-mtext">Quick Service</span>
                  </Link>
                </li>
                <li
                  className=" "
                  style={{ display: 'none' }}
                >
                  <Link to="/ServiceProviders/CarsAgent">
                    <span className="pcoded-mtext">Cars Agent</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
          <ul className="pcoded-item pcoded-left-item">
            <li className=" pcoded-hasmenu">
              <a href="javascript:void(0)">
                <span className="pcoded-micon">
                  <TbMenuOrder />
                </span>
                <span className="pcoded-mtext">Order Master</span>
              </a>
              <ul className="pcoded-submenu">
                <li className="">
                  <Link to="/payment">
                    <span className="pcoded-mtext">Orders</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
          <ul className="pcoded-item pcoded-left-item">
            <li className=" pcoded-hasmenu">
              <a href="javascript:void(0)">
                <span className="pcoded-micon">
                  <TbHotelService />
                </span>
                <span className="pcoded-mtext">Business Category Master</span>
              </a>
              <ul className="pcoded-submenu">
                <li className=" ">
                  <Link to="/BusinessCategoryMaster/GarageCategory">
                    <span className="pcoded-mtext">Garage Category</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/BusinessCategoryMaster/SparePartsCategory">
                    <span className="pcoded-mtext">Spare Parts Category</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/BusinessCategoryMaster/CarDealersCategory">
                    <span className="pcoded-mtext">Car Dealers Category</span>
                  </Link>
                </li>
                <li>
                  <Link to="/BusinessCategoryMaster/CarWashCategory">
                    <span className="pcoded-mtext ">Car Wash Category</span>
                  </Link>
                </li>
                <li>
                  <Link to="/BusinessCategoryMaster/CarInsuranceCategory">
                    <span className="pcoded-mtext">Car Insurance Category</span>
                  </Link>
                </li>
                <li>
                  <Link to="/BusinessCategoryMaster/DrivingSchoolCategory">
                    <span className="pcoded-mtext">DrivingSchool Category</span>
                  </Link>
                </li>
                <li>
                  <Link to="/BusinessCategoryMaster/CarProtectionCategory">
                    <span className="pcoded-mtext">
                      Car Protection Category
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/BusinessCategoryMaster/CarConditioningCategory">
                    <span className="pcoded-mtext">
                      Car Conditioning Category
                    </span>
                  </Link>
                </li>
                <li
                  className=" "
                  style={{ display: 'none' }}
                >
                  <Link to="/BusinessCategoryMaster/CarsAgentCategory">
                    <span className="pcoded-mtext">Cars Agent Category</span>
                  </Link>
                </li>
              </ul>
            </li>
            <li className=" pcoded-hasmenu">
              <a href="javascript:void(0)">
                <span className="pcoded-micon">
                  <MdOutlineCategory />
                </span>
                <span className="pcoded-mtext">Service Type Master</span>
              </a>
              <ul className="pcoded-submenu">
                <li>
                  <Link to="/ServiceTypeMaster/CarService">
                    <span className="pcoded-mtext">AC Service</span>
                  </Link>
                </li>
                <li>
                  <Link to="/ServiceTypeMaster/quickService">
                    <span className="pcoded-mtext">quick Service</span>
                  </Link>
                </li>
              </ul>
            </li>
            <li className=" pcoded-hasmenu">
              <a href="javascript:void(0)">
                <span className="pcoded-micon">
                  <MdOutlineSettingsInputComposite />
                </span>
                <span className="pcoded-mtext">Car Detail</span>
              </a>
              <ul className="pcoded-submenu">
                <li>
                  <Link to="/CarDetail/CarBrand">
                    <span className="pcoded-mtext">Car Brand</span>
                  </Link>
                </li>
                <li>
                  <Link to="/CarDetail/CarModel">
                    <span className="pcoded-mtext">Car Model & Series</span>
                  </Link>
                </li>
                <li>
                  <Link to="/CarDetail/Cylinder">
                    <span className="pcoded-mtext">Cylinder</span>
                  </Link>
                </li>
                <li>
                  <Link to="/CarDetail/ModelYear">
                    <span className="pcoded-mtext">Model Year</span>
                  </Link>
                </li>
                <li>
                  <Link to="/CarDetail/FuelType">
                    <span className="pcoded-mtext">Fuel Type</span>
                  </Link>
                </li>
                <li>
                  <Link to="/CarDetail/Doors">
                    <span className="pcoded-mtext">Doors</span>
                  </Link>
                </li>
                <li>
                  <Link to="/CarDetail/Seats">
                    <span className="pcoded-mtext">Seats</span>
                  </Link>
                </li>
                <li>
                  <Link to="/CarDetail/Color">
                    <span className="pcoded-mtext">Color</span>
                  </Link>
                </li>
                <li>
                  <Link to="/CarDetail/Safety">
                    <span className="pcoded-mtext">Safety</span>
                  </Link>
                </li>
                <li>
                  <Link to="/CarDetail/Comfort">
                    <span className="pcoded-mtext">Comfort</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>

          <ul className="pcoded-item pcoded-left-item">
            <li className=" pcoded-hasmenu">
              <a href="javascript:void(0)">
                <span className="pcoded-micon">
                  <TfiSettings />
                </span>
                <span className="pcoded-mtext">Spare Part Master</span>
              </a>
              <ul className="pcoded-submenu">
                <li className=" ">
                  <Link to="/SparePartMaster/SpareParts">
                    <span className="pcoded-mtext">Spare Parts </span>
                  </Link>
                </li>
                {/* <li className=' '>
									<Link to='/SparePartMaster/SparePartTypes'>
										<span className='pcoded-mtext'>Spare Part Types </span>
									</Link>
								</li> */}
                <li
                  className=" "
                  style={{ display: 'none' }}
                >
                  <Link to="/ProductMaster">
                    <span className="pcoded-mtext">Product Master</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>

          <ul className="pcoded-item pcoded-left-item">
            <li className="" style={{ display: 'none' }}>
              <Link to="/notification">
                <span className="pcoded-micon">
                  <MdNotificationsActive />
                </span>
                <span className="pcoded-mtext">Notification</span>
              </Link>
            </li>
          </ul>
          <ul className="pcoded-item pcoded-left-item">
            <li className="" style={{ display: 'none' }}>
              <Link to="/area">
                <span className="pcoded-micon">
                  <MdAddLocationAlt />
                </span>
                <span className="pcoded-mtext">Area Master</span>
              </Link>
            </li>
          </ul>

          <div className="pcoded-navigatio-lavel">Settings</div>
          <ul className="pcoded-item pcoded-left-item">
            <li className="">
              <Link to="/about">
                <span className="pcoded-micon">
                  <BsInfoLg />
                </span>
                <span className="pcoded-mtext">About Us</span>
              </Link>
            </li>
            <li className="">
              <Link to="/terms">
                <span className="pcoded-micon">
                  <CgNotes />
                </span>
                <span className="pcoded-mtext">Terms & Conditions</span>
              </Link>
            </li>
            <li className="">
              <Link to="/contact-us">
                <span className="pcoded-micon">
                  <MdOutlineCall />
                </span>
                <span className="pcoded-mtext">Contact Us</span>
              </Link>
            </li>
            {/* <li className=''>
							<Link to='/delete-business-data'>
								<span className='pcoded-micon'>
									<RiDeleteBin3Line />
								</span>
								<span className='pcoded-mtext'>Delete Business Data</span>
							</Link>
						</li> */}
          </ul>
        </div>
      </nav>
    );
  }
}

export default SideNavBar;
